import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Certificates from "./Certificates";
import LoadingSpinner from "./LoadingSpinner";

const MyQualification = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  // Updated image paths - remove "public" from the path
  const images = [
    "/ss/1.png",
    "/ss/2.png",
    "/ss/3.png",
    "/ss/4.png",
    "/ss/5.png",
    "/ss/6.png",
  ];

  // Added responsive settings for better mobile view
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: true,
        },
      },
    ],
  };

  return (
    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        // padding: "5%",
        margin: "7%",
      }}
    >
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div>
          <h2
            style={{
              fontSize: "2rem",
              marginBottom: "1rem",
              color: "#333",
            }}
          >
            My Qualifications
          </h2>

          <p
            style={{
              color: "#808080",
              lineHeight: "1.6",
              marginBottom: "2rem",
            }}
          >
            Full Stack Developer with 3.5+ years of experience in building
            high-quality, enterprise-level applications. My expertise includes
            React.js, Next.js, JavaScript, Go, Java, PHP, and Firebase with both
            relational, non - relational dbs. I specialize in developing fully
            responsive, SEO-friendly websites tailored to your needs. Let's work
            together to create exceptional digital experiences. Feel free to
            reach out anytime! 🚀
          </p>

          <h3
            style={{
              color: "#424242",
              marginTop: "1%",
              fontSize: "1.2rem",
              marginBottom: "1.5rem",
            }}
          >
            Reviews About My Services By Clients,
          </h3>

          <div
            style={{
              marginTop: "30px",
              maxWidth: "800px",
              margin: "0 auto",
            }}
          >
            <Slider {...settings}>
              {images.map((image, index) => (
                <div key={index} style={{ outline: "none" }}>
                  <img
                    src={image}
                    alt={`Client Review ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "400px",

                      borderRadius: "10px",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/placeholder-image.png"; // Add a placeholder image in public folder
                    }}
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      )}

      <div>
        <h2
          style={{
            fontSize: "2rem",
            marginBottom: "1rem",
            color: "#333",
            marginTop: "3%",
          }}
        >
          My Certifications
        </h2>
        <Certificates />
      </div>
    </div>
  );
};

export default MyQualification;
